// src/screens/DetalleReporteScreen.js
import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { db } from '../firebaseConfig';
import { doc, getDoc, updateDoc } from 'firebase/firestore';
import { useAuth } from '../context/AuthContext';
import { IoArrowBack, IoDownloadOutline, IoWarningOutline, IoPersonOutline, IoCalendarOutline, IoAlbumsOutline } from 'react-icons/io5';
import AIAssistantButton from '../components/Shared/AIAssistantButton';
import moment from 'moment';
import 'moment/locale/es';
import './DetalleReporteScreen.css';
import KondoSidebar from '../components/Shared/KondoSidebar';
import KondoBrandHeader from '../components/Shared/KondoBrandHeader';
import KondoBottomNav from '../components/Shared/KondoBottomNav';


function DetalleReporteScreen() {
  const navigate = useNavigate();
  const { reporteId } = useParams();
  const { userData } = useAuth();

  const [reporte, setReporte] = useState(null);
  const [estatus, setEstatus] = useState('');
  const [comentariosAdmin, setComentariosAdmin] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  // 1. Cargar los datos del reporte
  useEffect(() => {
    if (!reporteId || !userData?.condominioId) {
      return;
    }

    setLoading(true);
    const fetchReporte = async () => {
      try {
        const docRef = doc(db, "reportes", reporteId);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          const data = docSnap.data();
          if (data.condominioId !== userData.condominioId) {
            setError("No tienes permiso para ver este reporte.");
          } else {
            setReporte(data);
            setEstatus(data.estatus);
            setComentariosAdmin(data.comentariosAdmin || '');
          }
        } else {
          setError("No se encontró el reporte.");
        }
      } catch (e) {
        setError("Error al cargar el reporte.");
        console.error(e);
      }
      setLoading(false);
    };

    fetchReporte();
  }, [reporteId, userData]);

  // 2. Guardar el cambio de estatus Y los comentarios
  const handleUpdateReporte = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const docRef = doc(db, "reportes", reporteId);
      await updateDoc(docRef, {
        estatus: estatus,
        comentariosAdmin: comentariosAdmin
      });
      // Optional: Just show alert or maybe a toast?
      alert("Reporte actualizado con éxito.");
      navigate('/gestion-reportes');
    } catch (e) {
      console.error("Error al actualizar reporte: ", e);
      setError("Error al guardar el cambio.");
      setLoading(false);
    }
  };

  // --- Render Hooks ---
  return (
    <div className="ks-page">
      <KondoSidebar activeRoute="/gestion-reportes" />
      <main className="ks-main">
        <div className="ks-header-sticky-wrapper">
          <KondoBrandHeader showBack={false} />
        </div>
        <div className="ks-scroll-area">
          {loading ? (
            <div className="detalle-reporte-container" style={{ padding: '20px' }}>
              <p style={{ textAlign: 'center', marginTop: '50px', color: '#6b7280' }}>Cargando información...</p>
            </div>
          ) : error ? (
            <div className="detalle-reporte-container" style={{ padding: '15px' }}>
              <div className="app-header-sticky" style={{ padding: 0, marginBottom: '15px' }}>
                <div className="kondo-banner-standard" style={{ background: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)', margin: 0 }}>
                  <div className="banner-standard-content">
                    <button onClick={() => navigate('/gestion-reportes')} className="banner-back-btn-standard">
                      <IoArrowBack size={24} />
                    </button>
                    <div className="banner-standard-text">
                      <h2>Error</h2>
                      <p>No se pudo cargar el reporte</p>
                    </div>
                  </div>
                  <IoWarningOutline className="banner-standard-icon-decor" />
                </div>
              </div>
              <div className="detalle-card" style={{ textAlign: 'center', padding: '50px', margin: 0 }}>
                <IoWarningOutline size={50} color="#ef4444" />
                <p style={{ marginTop: '20px', fontSize: '1.2rem' }}>{error}</p>
              </div>
            </div>
          ) : !reporte ? (
            <div className="detalle-reporte-container" style={{ padding: '20px' }}>
              <p style={{ textAlign: 'center', marginTop: '50px', color: '#6b7280' }}>No se encontró el reporte.</p>
            </div>
          ) : (
            <div className="detalle-reporte-container" style={{ padding: 0 }}>
              {/* Sticky Compact Header */}
              <div className="app-header-sticky" style={{ padding: '15px 15px 0' }}>
                <div className="kondo-banner-standard" style={{ background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)', margin: 0 }}>
                  <div className="banner-standard-content">
                    <button onClick={() => navigate('/gestion-reportes')} className="banner-back-btn-standard">
                      <IoArrowBack size={24} />
                    </button>
                    <div className="banner-standard-text">
                      <h2>Detalle del Reporte</h2>
                      <p>Revisa y gestiona la incidencia</p>
                    </div>
                  </div>
                  <div className="banner-standard-actions">
                    <IoWarningOutline size={22} color="white" style={{ opacity: 0.8 }} />
                  </div>
                  <IoWarningOutline className="banner-standard-icon-decor" />
                </div>
              </div>

              {/* Main Card */}
              <div className="detalle-card" style={{ margin: '15px 15px 30px' }}>
                {/* Info Section */}
                <div className="info-section">
                  <h3>Información General</h3>
                  <div className="info-grid">
                    <div className="info-item">
                      <label><IoPersonOutline /> Residente</label>
                      <p>{reporte.nombreResidente || 'Anónimo'}</p>
                    </div>
                    <div className="info-item">
                      <label><IoAlbumsOutline /> Unidad</label>
                      <p>{reporte.unidadResidente || 'N/A'}</p>
                    </div>
                    <div className="info-item">
                      <label><IoCalendarOutline /> Fecha</label>
                      <p>{moment(reporte.fechaCreacion?.toDate()).format('D [de] MMMM YYYY, h:mm a')}</p>
                    </div>
                    <div className="info-item">
                      <label>Tipo</label>
                      <p style={{ textTransform: 'capitalize' }}>{reporte.tipo}</p>
                    </div>
                  </div>
                </div>

                {/* Description Section */}
                <div className="info-section">
                  <h3>Descripción del Problema</h3>
                  <div style={{ background: '#f9fafb', padding: '15px', borderRadius: '12px', lineHeight: '1.6' }}>
                    {reporte.descripcion}
                  </div>
                </div>

                {/* Attachments Section */}
                {reporte.archivoUrl && (
                  <div className="info-section">
                    <h3>Evidencia Adjunta</h3>
                    {reporte.archivoUrl.match(/\.(jpeg|jpg|gif|png|webp)$/i) ? (
                      <a href={reporte.archivoUrl} target="_blank" rel="noopener noreferrer">
                        <img src={reporte.archivoUrl} alt="Evidencia" className="report-image-preview" />
                      </a>
                    ) : (
                      <a href={reporte.archivoUrl} target="_blank" rel="noopener noreferrer" className="btn-update" style={{ background: '#f3f4f6', color: '#374151', padding: '10px' }}>
                        <IoDownloadOutline /> Ver Archivo Adjunto
                      </a>
                    )}
                  </div>
                )}

                {/* Update Form */}
                <div className="info-section" style={{ marginTop: '40px', borderTop: '2px dashed #e5e7eb', paddingTop: '30px' }}>
                  <h3>Gestión del Incidente</h3>
                  <form onSubmit={handleUpdateReporte}>
                    <div style={{ marginBottom: '20px' }}>
                      <label className="info-item" style={{ display: 'block', marginBottom: '8px' }}>STATUS ACTUAL</label>
                      <select
                        value={estatus}
                        onChange={(e) => setEstatus(e.target.value)}
                        className="status-select"
                      >
                        <option value="Pendiente">⚠️ Pendiente</option>
                        <option value="En Proceso">🔨 En Proceso</option>
                        <option value="Solucionado">✅ Solucionado</option>
                        <option value="Cancelado">🚫 Cancelado</option>
                      </select>
                    </div>

                    <div style={{ marginBottom: '20px' }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                        <label className="info-item" style={{ margin: 0 }}>NOTA DEL ADMINISTRADOR (VISIBLE PARA EL RESIDENTE)</label>
                        <AIAssistantButton 
                          textoOriginal={comentariosAdmin}
                          onSugerenciaAceptada={(nuevoTexto) => setComentariosAdmin(nuevoTexto)}
                          contexto="incidencias"
                        />
                      </div>
                      <textarea
                        className="comment-box"
                        rows={4}
                        value={comentariosAdmin}
                        onChange={(e) => setComentariosAdmin(e.target.value)}
                        placeholder="Escribe una actualización para el residente..."
                      />
                    </div>

                    <button type="submit" className="action-btn-primary" disabled={loading} style={{ width: '100%', marginTop: '10px' }}>
                      {loading ? 'Guardando...' : 'Actualizar Reporte'}
                    </button>
                  </form>
                </div>
              </div>
            </div>
          )}
        </div>
        <KondoBottomNav activeRoute="/gestion-reportes" />
      </main>
    </div>
  );
}

export default DetalleReporteScreen;